import { withProcedureWraper } from "../../../..";
import {
  ApprovalHistory,
  Box,
  BoxSection,
  ButtonList,
  Chats,
  Error,
  Icon,
  Loading,
  Steps,
} from "../../../../../../components";
import { useHistory } from "react-router-dom";
import { Col, Input, Row, Spin, notification } from "antd";
import BoxSectionItem from "../../../../../../components/box-section/box-section-item";
import { useCourseColumns } from "../../hooks/use-course-columns";
import { useMTPRequest, useMTPSteps, useUpdateMTP } from "../../hooks";
import { CoursesTable } from "../../components";
import { EnvHelper, StringHelper } from "../../../../../../helper";
import { useState } from "react";
import { IAPItem } from "../../../../../../hook";
import { EnvKey, RequestStatus } from "../../../../../../constants";
import { useQueryClient } from "@tanstack/react-query";
import { Routes } from "../../../../../../AppRoutes";

const siteUrl = EnvHelper.getValue(EnvKey.APPROVER_MTP_URL);

const MTPDetail = withProcedureWraper(() => {
  const history = useHistory();
  const queryClient = useQueryClient();
  const [reason, setReason] = useState("");

  const { columns } = useCourseColumns();
  const { data = {}, isFetching, isError } = useMTPRequest();
  const { mutate, isLoading: isUpdateLoading } = useUpdateMTP();
  const { approve, getStepItems, getApprovalHistory, updateSteps, sendMailAP } =
    useMTPSteps();
  const { isApprovedUser, userStep, stepNumber, stepStatus, canEdit } = approve(
    data?.eApprovalProcess
  );

  const handleApprove = () => {
    const newStep: IAPItem = {
      ...userStep,
      status: RequestStatus.approved,
      reason,
    };
    const newApprovalProcess = updateSteps(data?.eApprovalProcess, newStep);
    const updatedFields = {
      eApprovalProcess: newApprovalProcess,
      eRequestStatus: userStep.requestStatus,
    };
    mutate(
      { id: data.id, body: updatedFields },
      {
        onSuccess(response: any) {
          queryClient.invalidateQueries({
            queryKey: ["MTP-requests"],
          });
          sendMailAP(response.eApprovalProcess, {
            toPath: `${siteUrl}/${response.id}`,
            type: RequestStatus.approved,
          });
          notification.success({
            message: "Thành công!",
            description: `Duyệt yêu cầu thành công.`,
          });
        },
        onError() {
          notification.error({
            message: "Thất bại",
            description: `Duyệt yêu cầu thất bại.`,
          });
        },
      }
    );
  };
  const handleReject = () => {
    const newApprovalProcess = updateSteps(data?.eApprovalProcess, {
      ...userStep,
      status: RequestStatus.rejected,
      reason,
    });
    const updatedFields = {
      eApprovalProcess: newApprovalProcess,
      eRequestStatus: RequestStatus.rejected,
    };
    mutate(
      { id: data.id, body: updatedFields },
      {
        onSuccess(response: any) {
          queryClient.invalidateQueries({
            queryKey: ["MTP-requests"],
          });
          sendMailAP(response.eApprovalProcess, {
            toPath: `${siteUrl}/${response.id}`,
            type: RequestStatus.rejected,
          });
          notification.success({
            message: "Thành công!",
            description: `Từ chối yêu cầu thành công.`,
          });
        },
        onError() {
          notification.error({
            message: "Thất bại",
            description: `Từ chối yêu cầu thất bại.`,
          });
        },
      }
    );
  };

  if (isFetching) return <Loading />;
  if (isError) return <Error description="Không tìm thấy dữ liệu" />;
  return (
    <Spin spinning={isUpdateLoading}>
      <div className="pd15">
        <div className="PageHead flex-center">
          <div className="title" style={{ margin: 0 }}>
            <div className="btnBack" onClick={() => history.goBack()}>
              <Icon.ArrowLeft />
            </div>
            Xem xét yêu cầu phê duyệt
          </div>
        </div>
        <Box title="Quy trình duyệt">
          <Steps
            items={getStepItems(data?.eApprovalProcess)}
            current={stepNumber}
            status={stepStatus}
          />
        </Box>
        <Box title="Thông tin">
          <BoxSection title="Thông tin kế hoạch đào tạo tháng">
            <Row gutter={[32, 0]}>
              <Col span={12}>
                <BoxSectionItem
                  textLeft="Họ tên người yêu cầu"
                  textRight={
                    StringHelper.verticalBarSplit<string[]>(data?.eCreatedBy)[1]
                  }
                />
              </Col>
              <Col span={12}>
                <BoxSectionItem
                  textLeft="Cơ quan / Đơn vị"
                  textRight={
                    StringHelper.verticalBarSplit<string[]>(
                      data?.eDepartment
                    )[1]
                  }
                />
              </Col>
            </Row>
          </BoxSection>
          <BoxSection title="Thông tin chi tiết">
            <CoursesTable
              columns={columns}
              dataSource={data?.eTrainingCourses}
            />
          </BoxSection>
          <BoxSection title="Lịch sử phê duyệt">
            <ApprovalHistory
              items={getApprovalHistory(data?.eApprovalProcess)}
            />
            {isApprovedUser && (
              <div className="pd15">
                <Input.TextArea
                  placeholder="Nhập lý do..."
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                />
              </div>
            )}
          </BoxSection>
          <BoxSection title="Thông tin trao đổi">
            <Chats
              items={data?.eComments}
              mutateFn={mutate}
              requestId={data.id}
            />
          </BoxSection>
        </Box>
        <div className="flex-center">
          <ButtonList
            items={[
              {
                buttonType: "success",
                label: "Đồng ý",
                hidden: !isApprovedUser,
                onClick: handleApprove,
              },
              {
                buttonType: "grey",
                label: "Không đồng ý",
                hidden: !isApprovedUser,
                onClick: handleReject,
              },
              {
                buttonType: "warning",
                label: "Chỉnh sửa",
                hidden: !canEdit,
                onClick: () =>
                  history.push(
                    `${Routes.monthlyTrainingPlanPage.path}/${data.id}/edit`
                  ),
              },
            ]}
          />
        </div>
      </div>
    </Spin>
  );
});

export default MTPDetail;
